import React from "react";
import { AaPlatformStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { Buttons, Inputs } from "components";

const AaPlatform = ({
  initialValues,
  roomOptions,
  isDisabledForm,
  onBack,
  onSubmit,
}) => {
  const schema = yup.object().shape({
    room_ref_id: yup.string().required("required"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: initialValues,
  });

  const { t } = useTranslation(["common", "form", "room"]);

  return (
    <AaPlatformStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.Radio
                {...field}
                disabled={isDisabledForm}
                options={roomOptions}
                errors={errors.room_ref_id?.message}
              />
            )}
            name="room_ref_id"
            defaultValue=""
          />
        </div>
        <div className="button_layout">
          <div className="button1">
            {!isDisabledForm && (
              <Buttons.BgStandard
                theme_white_purple
                label={t("Back", { ns: "common" })}
                onClick={onBack}
              />
            )}
          </div>
          <div className="button2">
            <Buttons.BgStandard
              theme_white_purple={isDisabledForm}
              label={t("Next", { ns: "common" })}
              type="submit"
            />
          </div>
        </div>
      </form>
    </AaPlatformStyled>
  );
};

AaPlatform.propTypes = {};

export default AaPlatform;
